module.exports = __webpack_public_path__ + "static/media/CN51Logo.c00b6091.png";